<section class="bg-platinum py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-5">
    <div class="mx-auto max-w-4xl text-center">
      <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        What <span class="text-turquoise">real bettors</span> are saying
      </h2>
    </div>

    <div class="mx-auto mt-12 grid max-w-none grid-cols-1 gap-4 lg:grid-cols-3">
      
      <div *ngFor="let testimonial of testimonials" class="flex flex-col rounded-2xl bg-turquoise/10 p-8 card-hover-effect">
        <div class="flex items-center gap-x-1">
          <ng-container *ngFor="let i of createLoopArray(testimonial.rating)">
            <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10.868 2.884c.321-.662 1.215-.662 1.536 0l1.681 3.468 3.821.556c.734.107 1.028.998.494 1.513l-2.766 2.695.653 3.803c.124.722-.643 1.279-1.286.944l-3.417-1.797-3.417 1.797c-.643.335-1.41-.222-1.286-.944l.653-3.803-2.766-2.695c-.534-.515-.24-1.406.494-1.513l3.821-.556L9.132 2.884z" clip-rule="evenodd" />
            </svg>
          </ng-container>
        </div>

        <blockquote class="mt-6 text-base leading-7 text-gray-300">
          <p>"{{ testimonial.text }}"</p>
        </blockquote>

        <footer class="mt-6">
          <p class="text-base font-semibold text-white">{{ testimonial.author }}</p>
        </footer>
      </div>
    </div>
  </div>
</section>